import Component from '@glimmer/component';
import notEq from 'ember-truth-helpers/helpers/not-eq';
import { LinkTo } from '@ember/routing';
import HeroIcon from 'bcl/components/hero-icon';
import { action } from '@ember/object';

interface EventsListSignature {
  // The arguments accepted by the component
  Args: {};
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class EventsListComponent extends Component<EventsListSignature> {
  <template>
    <div class="flow-root mt-4">
      <ul role="list" class="-mb-8">
        {{#each this.timeline as |event eventIdx|}}
          <li>
            <div class="relative pb-8">
              {{#if (notEq eventIdx this.lengthMinusOne)}}
                <span
                  class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"
                  aria-hidden="true"
                />
              {{/if}}
              <div class="relative flex space-x-3">
                <div>
                  {{#if event.routeModel}}
                    <LinkTo
                      @route={{event.route}}
                      @model={{event.routeModel}}
                      class="font-medium text-gray-900"
                    >
                      <span
                        class="{{event.iconBackground}}
                          h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                      >
                        <HeroIcon
                          @icon={{event.icon}}
                          class="h-5 w-5 text-white"
                          aria-hidden="true"
                        />
                      </span>
                    </LinkTo>
                  {{else if event.route}}
                    <LinkTo
                      @route={{event.route}}
                      class="font-medium text-gray-900"
                    >
                      <span
                        class="{{event.iconBackground}}
                          h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                      >
                        <HeroIcon
                          @icon={{event.icon}}
                          class="h-5 w-5 text-white"
                          aria-hidden="true"
                        />
                      </span>
                    </LinkTo>
                  {{else}}
                    <a href="{{event.href}}" class="font-medium text-gray-900">
                      <span
                        class="{{event.iconBackground}}
                          h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                      >
                        <HeroIcon
                          @icon={{event.icon}}
                          class="h-5 w-5 text-white"
                          aria-hidden="true"
                        />
                      </span>
                    </a>
                  {{/if}}
                </div>
                <div
                  class="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5"
                >
                  <div>
                    <p class="text-sm text-gray-500">
                      {{event.content}}

                    </p>
                  </div>
                  <div
                    class="whitespace-nowrap text-right text-sm text-gray-500"
                  >
                    <time
                      datetime={{this.datetime event.datetime}}
                    >{{this.formatDate event.datetime}}</time>
                  </div>
                </div>
              </div>
            </div>
          </li>
        {{/each}}
      </ul>
    </div>
  </template>
  names = ['Toni', 'Peter', 'Assem'];
  startDate = new Date('2025-07-04');
  formatter = new Intl.DateTimeFormat('de-DE', {
    weekday: 'short',
    month: 'long',
    day: 'numeric',
  });
  @action
  formatDate(date: Date) {
    return this.formatter.format(date);
  }
  @action
  datetime(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  offsetDate(numDays: number): Date {
    const date = new Date(this.startDate);
    date.setDate(date.getDate() + numDays);
    return date;
  }
  timeline = [
    {
      content: this.names[0] + ' hat ein neues Lager angelegt',
      route: 'auth.location',
      datetime: this.offsetDate(1),
      icon: 'archive-box',
      iconBackground: 'bg-blue-500',
    },
    {
      content: this.names[1] + ' hat einen neuen Lieferanten hinzugefügt',
      route: 'auth.basic-data',
      datetime: this.offsetDate(1),
      icon: 'building-office',
      iconBackground: 'bg-blue-500',
    },
    {
      content:
        this.names[2] +
        ' hat die Soll-Menge von Berliner Luft von 10 auf 20 erhöht',
      href: '/basic-data#items',
      datetime: this.offsetDate(2),
      icon: 'chevron-up',
      iconBackground: 'bg-green-500',
    },
    {
      content:
        this.names[0] +
        ' hat den Verkaufspreis von Berliner Luft auf 1€ gesenkt',
      href: '/basic-data#items',
      datetime: this.offsetDate(4),
      icon: 'currency-euro',
      iconBackground: 'bg-red-500',
    },
    {
      content:
        this.names[1] +
        ' hat die Soll-Menge von Berliner Luft von 20 auf 10 reduziert',
      href: '/basic-data#items',
      datetime: this.offsetDate(5),
      icon: 'chevron-down',
      iconBackground: 'bg-red-500',
    },
    {
      content: this.names[2] + ' hat eine Bestellung angelegt',
      route: 'auth.orders',
      datetime: this.offsetDate(6),
      icon: 'clipboard',
      iconBackground: 'bg-blue-500',
    },
    {
      content: this.names[0] + ' hat eine Bestellung angenommen',
      route: 'auth.orders',
      datetime: this.offsetDate(10),
      icon: 'check',
      iconBackground: 'bg-green-500',
    },
  ].reverse();
  get lengthMinusOne() {
    return this.timeline.length - 1;
  }
}
